// export default function Services() {
//   const services = [
//     { name: "Exterior Wash", desc: "Spot-free rinse, foam, air dry." },
//     { name: "Interior Clean", desc: "Vacuum, dash, windows, mats." },
//     { name: "Deluxe Detail", desc: "Wheel clean, wax, interior refresh." },
//     { name: "Premium Polish", desc: "Hand polish & paint protect." },
//   ];
//   return (
//     <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-24">
//       <h1 className="text-4xl font-extrabold">Services</h1>
//       <div className="mt-10 grid gap-6 sm:grid-cols-2">
//         {services.map((s)=>(
//           <div key={s.name} className="rounded-2xl p-6 ring-1 ring-black/10 bg-white">
//             <h3 className="font-bold text-lg">{s.name}</h3>
//             <p className="text-gray-600 mt-2">{s.desc}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

import React from "react";
import { Link } from "react-router-dom";

export default function Services() {
  const services = [
    {
      id: "automatic",
      title: "Automatic Wash",
      blurb: "Pamper your vehicle with our fast, touch-free automatic wash.",
      img: "/automatic.png",
      chip: "Exterior",
    },
    {
      id: "self-serve-bays",
      title: "Self-Serve Bays",
      blurb: "Spacious bays to get those tough-to-reach spots.",
      img: "/selfservebay.png",
      chip: "Exterior",
    },
    {
      id: "big-bay",
      title: "Truck / RV / Auto Wash Bay",
      blurb: "Extra-large bay to accommodate large Recreational Vehicles.",
      img: "/bigbay.png",
      chip: "Oversize",
    },
    {
      id: "vacuums",
      title: "Self-Serve Vacuums",
      blurb: "Finish the job with our powerful vacuums.",
      img: "/vacuum.png",
      chip: "Interior",
    },
    {
      id: "vending",
      title: "Vending Detail Center",
      blurb: "Stocked with the items you need to detail inside & out.",
      img: "/vending.png",
      chip: "Detailing",
    },
  ];

  return (
    <main className="bg-[#0a1220] min-h-screen">
      {/* Page header */}
      <section className="text-center py-20">
        <h1 className="text-5xl md:text-6xl font-extrabold text-white mb-6">
          Our Services
        </h1>
        <div className="flex justify-center mb-6">
          <div className="h-2 w-32 rounded-full bg-cyan-400" />
        </div>
        <p className="text-white/80">Exterior • Interior • Oversize • Detailing</p>
      </section>

      {/* Cards */}
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-20">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((s) => (
            <ServiceCard key={s.id} service={s} />
          ))}
        </div>

        {/* CTA row */}
        <div className="mt-14 flex flex-wrap gap-4 justify-center">
          <Link
            to="/pricing"
            className="px-6 py-3 rounded-lg bg-cyan-400 text-[#0a1220] font-semibold"
          >
            View Pricing
          </Link>
          <Link
            to="/contact"
            className="px-6 py-3 rounded-lg border border-white/30 text-white hover:bg-white/10"
          >
            Contact Us
          </Link>
        </div>
      </section>
    </main>
  );
}

function ServiceCard({ service }) {
  return (
    <article className="group overflow-hidden rounded-3xl bg-white/5 ring-1 ring-white/10 shadow-xl">
      <div className="aspect-[4/3] w-full overflow-hidden">
        <img
          src={service.img}
          alt={service.title}
          className="h-full w-full object-cover transition duration-300 group-hover:scale-[1.03]"
        />
      </div>

      <div className="p-6 text-white text-left">
        <div className="mb-3 inline-flex items-center rounded-full bg-cyan-400/20 px-3 py-1 text-xs font-semibold text-cyan-300 ring-1 ring-cyan-400/30">
          {service.chip}
        </div>

        <h3 className="text-2xl font-extrabold">{service.title}</h3>
        <p className="mt-2 text-white/85">{service.blurb}</p>

        {/* Optional feature bullets (blue dots), if you want to add later:
        <ul className="mt-4 space-y-2">
          {["Example feature A", "Example feature B"].map((f, i) => (
            <li key={i} className="flex gap-3 items-start">
              <span className="mt-2 h-2.5 w-2.5 rounded-full bg-cyan-400 shrink-0" />
              <span>{f}</span>
            </li>
          ))}
        </ul>
        */}
      </div>
    </article>
  );
}
